import { gql } from "@apollo/client";

export const GET_INDICACION_INSUMO_DISPO = gql`
  query getIndicacionInsumosDispo($idIndicacion: Int!, $idEvaluacion: Int!) {
    indicacionInsumosDispo(
      idIndicacion: $idIndicacion
      idEvaluacion: $idEvaluacion
    ) {
      success
      error
      valorEsperado {
        idInsumoN
        descripcion
        idUnidad
        unidad
      }
    }
  }
`;